const verification_record = {
    not_found: 'Doğrulama kaydı bulunamadı.',
    permission_denied: 'İzin reddedildi, lütfen tekrar kimlik doğrulaması yapın.',
    not_supported_for_google_one_tap: "Bu API, Google One Tap'i desteklemiyor.",
};
export default Object.freeze(verification_record);
